export default {
  banner: {
    title: "Common Login Component ",
    subtitle:
      "The Login Component (Guard) is an embeddable login form that can be configured to suit your needs and easily add a variety of social login methods so that your users can log in seamlessly and have a consistent login experience across platforms.",
  },
};
